var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_593_4756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6309 22.7212L22.7212 15.6309C23.1918 15.1615 23.8294 14.8978 24.494 14.8978C25.1588 14.8978 25.7963 15.1615 26.2669 15.6309C26.7364 16.1015 27 16.739 27 17.4038C27 18.0684 26.7364 18.706 26.2669 19.1766L19.1766 26.2669C18.706 26.7364 18.0684 27 17.4038 27C16.739 27 16.1015 26.7364 15.6309 26.2669C15.1615 25.7963 14.8978 25.1588 14.8978 24.494C14.8978 23.8294 15.1615 23.1918 15.6309 22.7212ZM5.73313 16.3691C6.20365 16.8382 6.84101 17.1017 7.50547 17.1017C8.16996 17.1017 8.80732 16.8382 9.27783 16.3691L16.3691 9.27783C16.8382 8.80732 17.1017 8.16996 17.1017 7.50547C17.1017 6.84101 16.8382 6.20365 16.3691 5.73313C15.8985 5.26366 15.261 5 14.5962 5C13.9316 5 13.294 5.26366 12.8234 5.73313L5.73313 12.8234C5.26366 13.294 5 13.9316 5 14.5962C5 15.261 5.26366 15.8985 5.73313 16.3691ZM13.3394 18.6578C13.8099 19.1273 14.4475 19.3909 15.1122 19.3909C15.7769 19.3909 16.4145 19.1273 16.885 18.6578L18.6578 16.885C19.1273 16.4145 19.3909 15.7769 19.3909 15.1122C19.3909 14.4475 19.1273 13.8099 18.6578 13.3394C18.1873 12.8699 17.5497 12.6063 16.885 12.6063C16.2203 12.6063 15.5827 12.8699 15.1122 13.3394L13.3394 15.1122C12.8699 15.5827 12.6063 16.2203 12.6063 16.885C12.6063 17.5497 12.8699 18.1873 13.3394 18.6578Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_593_4756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHifi);
export default __webpack_public_path__ + "static/media/HIFI.b45d6f0645a258321ff289359312e27a.svg";
export { ForwardRef as ReactComponent };